import React, { PureComponent } from 'react';
import  {whiteLabelData}  from '../../ui/theme'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withTitle } from '../../Application';
import AboutView from '../../ui/views/Information/Information';
import {fetchDevices} from "../../connectors/Devices/actions";
import {apiClient} from "../../services/api";
import log from 'loglevel'
import {t} from 'i18next'

var pageTitle = ""
const title = whiteLabelData.name

const mapStateToProps = state => ({
  title: state.application.title,
  currentDeviceId: (state.devices.map[state.devices.active] || { settings: {} }).deviceid,
});

const mapDispatchToProps = dispatch => ({
  fetchDevices: () => dispatch(fetchDevices()),
});

/**
 * Scopes
 */
class Scopes extends PureComponent {
  static propTypes = {
  }

  static defaultProps = {
  }

  componentWillMount(){
    pageTitle = t('PageTitles.about') + whiteLabelData.name
    this.secondLoad()
  }

    secondLoad = () => {
      var data = { deviceid: this.props.currentDeviceId }
      log.debug("SECONDLOAD")
      apiClient.post('control/settings/store', data)
        .then(res => {
          if (res.status === 200) {
            log.debug("STATE UPDATE CMD OK")
            this.props.fetchDevices()
          }
        })
        .then(()=> {
          setTimeout(() =>{
            this.props.fetchDevices()
              log.debug("2 Seconds LATER")

        }, 2000)
        })
    }

  render() {
    return (
      <AboutView title={pageTitle} />
    );
  }
}

export default withTitle(withRouter(connect(mapStateToProps, mapDispatchToProps)(Scopes)), title);
